// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2X5di","footer":"ModalInfo_footer__3de-f"};